/** Motion off during prerender (crawlers must read final values) and for reduced motion users. */
export function motionAllowed() {
  if (typeof window === "undefined" || window.__PRERENDER__) return false;
  try {
    return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return true;
  }
}
